export default __webpack_public_path__ + "static/media/playlist-icon-white.5925da63.svg";